module.exports = __webpack_public_path__ + "img/checkmark.f2fdfbe8.svg";